import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import DashboardPage from "../pages/dashboard/page";
import MembersPage from "../pages/members/page";
import RewardsPage from "../pages/rewards/page";
import AnalyticsPage from "../pages/analytics/page";
import BankPage from "../pages/bank/page";
import AIPage from "../pages/ai/page";
import MarketPage from "../pages/market/page";
import VipPage from "../pages/vip/page";
import RecordsPage from "../pages/records/page";
import SettingsPage from "../pages/settings/page";
import ProtectedRoute from "../components/feature/ProtectedRoute";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/dashboard", element: <ProtectedRoute><DashboardPage /></ProtectedRoute> },
  { path: "/members", element: <ProtectedRoute><MembersPage /></ProtectedRoute> },
  { path: "/rewards", element: <ProtectedRoute><RewardsPage /></ProtectedRoute> },
  { path: "/analytics", element: <ProtectedRoute><AnalyticsPage /></ProtectedRoute> },
  { path: "/bank", element: <ProtectedRoute><BankPage /></ProtectedRoute> },
  { path: "/ai", element: <ProtectedRoute><AIPage /></ProtectedRoute> },
  { path: "/market", element: <ProtectedRoute><MarketPage /></ProtectedRoute> },
  { path: "/vip", element: <ProtectedRoute><VipPage /></ProtectedRoute> },
  { path: "/records", element: <ProtectedRoute><RecordsPage /></ProtectedRoute> },
  { path: "/settings", element: <ProtectedRoute><SettingsPage /></ProtectedRoute> },
  { path: "*", element: <NotFound /> },
];

export default routes;
